/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NewTournament } from '../models/NewTournament';
import type { Tournament } from '../models/Tournament';
import type { TournamentWithRelations } from '../models/TournamentWithRelations';
import type { UpdateTournament } from '../models/UpdateTournament';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class TournamentsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param requestBody Create new tournament
     * @returns Tournament Created Tournament model instance
     * @throws ApiError
     */
    public tournamentControllerAddTournament(
        requestBody?: NewTournament,
    ): CancelablePromise<Tournament> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/tournaments/add',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @param requestBody Update tournament
     * @returns void
     * @throws ApiError
     */
    public tournamentControllerUpdateTournament(
        id: number,
        requestBody?: UpdateTournament,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/admin/tournaments/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns void
     * @throws ApiError
     */
    public tournamentControllerDeleteTournament(
        id: number,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/admin/tournaments/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param includeTeams
     * @returns TournamentWithRelations Array of Tournament model instances
     * @throws ApiError
     */
    public tournamentControllerGetAllTournaments(
        includeTeams?: boolean,
    ): CancelablePromise<Array<TournamentWithRelations>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/tournaments',
            query: {
                'includeTeams': includeTeams,
            },
        });
    }
}
